// External
import _ from "lodash";
import React, { useState, useEffect, useRef } from "react";
import classNames from "classnames";

// Design system
import { Tooltip } from "@toddle-edu/ds-web";

// Utils
import { checkIsTextOverflowing } from "ToddleAnalytics/modules/Utils";
import ConditionalWrapper from "Utils/ConditionalWrapper";
import { multiLineEllipsis } from "Utils";

// SCSS
import classes from "./TextWithEllipsis.scss";

const TOOLTIP_OVERLAY_INNER_STYLE = {
  maxWidth: 344,
  wordBreak: "break-word",
};

const TextWithEllipsis = ({
  text,
  style,
  className,
  lineHeight = "2rem",
  lineCount = 1,
  isHTML = false,
  showArrow = false,
}) => {
  const textRef = useRef(null);
  const [isTextOverflowing, setIsTextOverflowing] = useState(false);

  useEffect(() => {
    const checkOverflow = () => {
      if (textRef.current && text) {
        const hasOverflow = checkIsTextOverflowing(textRef.current);
        setIsTextOverflowing(hasOverflow);
      }
    };

    const debouncedCheckOverflow = _.debounce(checkOverflow, 300);

    const timeoutId = setTimeout(debouncedCheckOverflow, 150);

    window.addEventListener("resize", debouncedCheckOverflow);

    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("resize", debouncedCheckOverflow);
    };
  }, [text]);

  const textContainerClasses = classNames(classes.textContainer, {
    [className]: className,
  });

  style = {
    wordBreak: "break-all",
    ...multiLineEllipsis({ lineHeight, lineCount }),
    ...style,
  };

  return (
    <ConditionalWrapper
      type="wrapperAsElement"
      condition={isTextOverflowing}
      wrapper={
        <Tooltip
          dsVersion="2.0"
          tooltip={text}
          showArrow={showArrow}
          overlayInnerStyle={TOOLTIP_OVERLAY_INNER_STYLE}
        />
      }
    >
      <span
        ref={textRef}
        data-line-height={lineHeight}
        style={style}
        className={textContainerClasses}
        dangerouslySetInnerHTML={isHTML ? { __html: text } : undefined}
      >
        {!isHTML ? text : null}
      </span>
    </ConditionalWrapper>
  );
};

export default TextWithEllipsis;
